export class Award {
  _id?: string;
  name: string = '';
  source: string = '';
  sourceUrl: string = '';
  image: string = '';
  created: Date;
  updated: Date;
}


// WEBPACK FOOTER //
// ./libs/atenea-cms-brand/src/awards/shared/award.model.ts